<template>
  <div class="newsDetail">
    <!--头部banner-->
    <div class="banner"></div>

    <!--主体-->
    <div class="main w">
      <div class="title">{{ newsInfo.title }}</div>
      <div class="desc">
        <span v-if="newsInfo.source">来源：{{ newsInfo.source }}</span>
        <span>时间：{{ newsInfo.createTime }}</span>
      </div>
      <div class="content" v-html="newsInfo.content"></div>
    </div>
  </div>
</template>

<script>
import Mock from './newsList.json'

export default {
  name: "newsDetail",
  data() {
    return {
      newsInfo: {},
    }
  },
  created() {
    this.$store.dispatch('setActive','/newsInfo')
    this.getDatailNews()
  },
  mounted() {
  },
  methods: {
    //获取文章详情
    async getDatailNews() {
      try {
        let res = await this.$http.get(this.$const.Platformconsulting.GetNewsInfo + this.$route.query.newsId)
        if (res.code === 200) {
          this.newsInfo = JSON.parse(JSON.stringify(res.data))
        }
      }catch (e) {
        // console.log(e);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.newsDetail {
  .banner {
    width: 100%;
    min-width: 1200px;
    height: 45vh;
    background: url('~@/assets/imgs/NewsCenter/news_center_banner.png') no-repeat;
    background-size: 100% 100%;
    background-position: center;
  }

  .main {
    padding: 55px 0;

    .title {
      text-align: center;
      font-size: 35px;
      line-height: 55px;
      padding: 10px 0;
    }

    .desc {
      color: #909090;
      font-size: 14px;
      margin: 0 0 15px 0;
      text-align: center;

      span:nth-child(2) {
        margin-left: 20px;
      }
    }
    .content {
      min-height: 400px;
    }
  }
}
</style>
